import React, { Component } from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { fetchExampleMapAsync, openEditor } from '../../actioncreators/actioncreators'

import CompletionInfo from './CompletionInfo'
import CreateExampleMap from './CreateExampleMap'
import Notes from './Notes'
import Questions from './Questions'
import Rules from './Rules'

let resizeCount = 0
let resizer

class Editor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      appLicensed: true
    }
  }

  componentWillMount () {
    const parsed = queryString.parse(window.location.search)
    if (parsed.lic !== 'active' && window.location.host !== 'localhost:3000') {
      this.setState({ appLicensed: false })
      return
    }
    this.props.fetchExampleMap()
  }

  componentDidMount() {
    // temporary fix for extensions not showing in Chrome due to iframe height 0.
    // resize seems very innocuous and can be called repeatedly with no ill effect
    // first resize helps in most cases but it seems like a race we sometimes lose
    // needs to move to jiraConnectAdapter (todo) after evaluation
    window.AP.resize()
    resizer = setInterval(this.resizeParentIframe, 1000)
  }

  resizeParentIframe() {
    window.AP.resize()
    resizeCount++
    if (resizeCount > 10) {
      clearInterval(resizer)
    }
  }

  render () {
    return <div>
      {!this.state.appLicensed && <p>Example Mapping for Jira is not currently licensed.</p>}
      {this.state.appLicensed && <div>
        {!this.props.showContent && <CreateExampleMap />}
        {this.props.showContent && <div>
          <button onClick={this.props.openDialog} className='btn btn-primary'>Edit Example Map</button>
          <div style={{ marginTop: 10, display: 'flex', flexFlow: 'row wrap', backgroundColor: '#f4f5f7', paddingLeft: '1.5%', paddingTop: '1.5%' }}>
            <CompletionInfo />
            <Rules />
          </div>
          <Questions />
          <Notes />
        </div>}
      </div>}
    </div>
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    note: store.notes.text,
    showContent: store.rules.flat().length > 0 || store.questions.length > 0 || store.notes.text.length > 0
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    fetchExampleMap: () => dispatch(fetchExampleMapAsync()),
    openDialog: () => {
      window.amplitude.getInstance().logEvent('em_open_editor')
      dispatch(openEditor())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
